import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { WareHouseDto } from "../dtos/warehouse/wareHouseDto";
import { getData } from "../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/warehouse`;

export const getAllWarehouses = async () => {
  return await getData<ResponseDto<WareHouseDto[]>>(baseUrl);
};

export const getWarehouseList = async (searchText:String) => {
  return await getData<ResponseDto<WareHouseDto[]>>(baseUrl, {
    params: {
      searchText
    }
  });
};
